/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ChecklistTemplate,
} from '../models/index';
import {
    ChecklistTemplateFromJSON,
    ChecklistTemplateToJSON,
} from '../models/index';

export interface CreateTemplateRequest {
    checklistTemplate: ChecklistTemplate;
}

export interface DeleteTemplateRequest {
    id: string;
}

export interface GetAllTemplatesRequest {
    status?: string;
}

export interface GetAllVersionsRequest {
    id: string;
}

export interface GetTemplateRequest {
    id: string;
}

export interface PublishTemplateRequest {
    id: string;
}

export interface UpdateTemplateRequest {
    id: string;
    checklistTemplate: ChecklistTemplate;
}

/**
 * 
 */
export class ChecklistTemplateControllerApi extends runtime.BaseAPI {

    /**
     */
    async createTemplateRaw(requestParameters: CreateTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChecklistTemplate>> {
        if (requestParameters['checklistTemplate'] == null) {
            throw new runtime.RequiredError(
                'checklistTemplate',
                'Required parameter "checklistTemplate" was null or undefined when calling createTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/checklist-templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChecklistTemplateToJSON(requestParameters['checklistTemplate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChecklistTemplateFromJSON(jsonValue));
    }

    /**
     */
    async createTemplate(requestParameters: CreateTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChecklistTemplate> {
        const response = await this.createTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async deleteTemplateRaw(requestParameters: DeleteTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/checklist-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteTemplate(requestParameters: DeleteTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteTemplateRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getAllTemplatesRaw(requestParameters: GetAllTemplatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChecklistTemplate>>> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/checklist-templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChecklistTemplateFromJSON));
    }

    /**
     */
    async getAllTemplates(requestParameters: GetAllTemplatesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChecklistTemplate>> {
        const response = await this.getAllTemplatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAllVersionsRaw(requestParameters: GetAllVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ChecklistTemplate>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAllVersions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/checklist-templates/{id}/versions`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ChecklistTemplateFromJSON));
    }

    /**
     */
    async getAllVersions(requestParameters: GetAllVersionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ChecklistTemplate>> {
        const response = await this.getAllVersionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getTemplateRaw(requestParameters: GetTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChecklistTemplate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/checklist-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChecklistTemplateFromJSON(jsonValue));
    }

    /**
     */
    async getTemplate(requestParameters: GetTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChecklistTemplate> {
        const response = await this.getTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async publishTemplateRaw(requestParameters: PublishTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChecklistTemplate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling publishTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/checklist-templates/{id}/publish`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChecklistTemplateFromJSON(jsonValue));
    }

    /**
     */
    async publishTemplate(requestParameters: PublishTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChecklistTemplate> {
        const response = await this.publishTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateTemplateRaw(requestParameters: UpdateTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChecklistTemplate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateTemplate().'
            );
        }

        if (requestParameters['checklistTemplate'] == null) {
            throw new runtime.RequiredError(
                'checklistTemplate',
                'Required parameter "checklistTemplate" was null or undefined when calling updateTemplate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/checklist-templates/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ChecklistTemplateToJSON(requestParameters['checklistTemplate']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChecklistTemplateFromJSON(jsonValue));
    }

    /**
     */
    async updateTemplate(requestParameters: UpdateTemplateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChecklistTemplate> {
        const response = await this.updateTemplateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
